export default (K: number): number => K / (1 + K);
